var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconReject(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M30.6673 16C30.6673 24.1002 24.1008 30.6667 16.0007 30.6667C7.90047 30.6667 1.33398 24.1002 1.33398 16C1.33398 7.89986 7.90047 1.33337 16.0007 1.33337C24.1008 1.33337 30.6673 7.89986 30.6673 16ZM22.2768 11.6095C22.7975 11.0888 22.7975 10.2446 22.2768 9.7239C21.7561 9.2032 20.9119 9.2032 20.3912 9.7239L16.0007 14.1144L11.6101 9.7239C11.0894 9.2032 10.2452 9.2032 9.72451 9.7239C9.20381 10.2446 9.20381 11.0888 9.72451 11.6095L14.115 16L9.72451 20.3906C9.20381 20.9113 9.20381 21.7555 9.72451 22.2762C10.2452 22.7969 11.0894 22.7969 11.6101 22.2762L16.0007 17.8857L20.3912 22.2762C20.9119 22.7969 21.7561 22.7969 22.2768 22.2762C22.7975 21.7555 22.7975 20.9113 22.2768 20.3906L17.8863 16L22.2768 11.6095Z",
    fill: "#FF5858"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconReject);
export default __webpack_public_path__ + "static/media/icon-reject.d6a93b3f2c2c286b3c3ae7830e61a532.svg";
export { ForwardRef as ReactComponent };